import { getHrefParam } from './ultile';
const STORE_PAGE_HREF_KEY = 'storePageHrefPAram';
const PAY_TYPE_LIST_KEY = 'payTypeListKey';
const PRODUCT_LIST_KEY = 'productListKey';
const PAY_TYPE_KEY = 'payTypeKey';
const LASTED_TYPE_KEY = 'lastedPayTypeKey';
const STORE_SERVER_ID_KEY = 'storeServerId';
const STORE_SERVER_NAME_KEY = 'storeServerName';
const RE_STORE_HREF_KEY = 'reStorePagetUrlKey';
const COIN_NAME_KEY = 'coinNameKey';
const LOCA_LCLSTOR_KEY = 'locationToSelect';
const CUR_LOCATION_KEY = 'currentLocation';
const DEFAULT_PRICE_KEY = 'defaultPriceKey';
const WEBVIEW_PAY_FLAG = 'webviewPageFlag';
const CHANGE_PRODUCT_ID = 'changeProductId';
const CP_PRODUCT_ID = 'cpProductIdKey';
const CREDIT_CARD_RECORD = 'creditCardRecord';
const PAYPAL_AGREEMENT_RECORD = 'paypalAgreementRecord';
const BIRTH_COUPONS = 'birthCoupons';
const AREA_LIMIT_AUTO_POPUO = 'areaLimitAutoPopup';

const normalizePayTypeList = (payList) => (Array.isArray(payList) ? payList : []);

export let storeLocation = function (locations) {
  let str = [];
  try {
    str = JSON.stringify(locations);
  } catch (e) {
    str = JSON.stringify([]);
  }
  sessionStorage.setItem(LOCA_LCLSTOR_KEY, str);
};

export let storePayTypeList = function (payList) {
  try {
    sessionStorage.setItem(
      PAY_TYPE_LIST_KEY,
      JSON.stringify(normalizePayTypeList(payList))
    );
  } catch (e) { }
};

export let getPayTYpeListStore = function () {
  try {
    return normalizePayTypeList(
      JSON.parse(sessionStorage.getItem(PAY_TYPE_LIST_KEY))
    );
  } catch (e) { return []; }
};

export let storeProductList = function (productList) {
  try {
    sessionStorage.setItem(PRODUCT_LIST_KEY, JSON.stringify(productList));
  } catch (e) { }
};

export let getProductListStore = function () {
  let productList = {};
  try {
    productList = JSON.parse(sessionStorage.getItem(PRODUCT_LIST_KEY));
  } catch (e) { }
  return productList;
};

export let getProductId = function () {
  let productId = '';
  try {
    productId = sessionStorage.getItem(CHANGE_PRODUCT_ID);
  } catch (e) { }
  return productId;
};

export let getCpProductId = () => {
  let cpProductId = '';
  try {
    cpProductId = sessionStorage.getItem(CP_PRODUCT_ID);
  } catch (e) { }
  return cpProductId;
};
// 切换商品要搞这个
export let storeProductId = function (productId) {
  try {
    sessionStorage.setItem(CHANGE_PRODUCT_ID, productId);
  } catch (e) { }
};

export let storeCpProductId = cpProductId => {
  try {
    sessionStorage.setItem(CP_PRODUCT_ID, cpProductId);
  } catch (e) { }
};

export let getProductList = () => {
  let products = getProductListStore();
  if (Array.isArray(products)) {
    return products.reduce((arr, item) => {
      arr = arr.concat(item.list);
      return arr;
    }, []);
  } else {
    return [];
  }
};

export let getProductById = function (productId) {
  let products = getProductListStore() || [];
  for (let i = 0, len = products.length; i < len; i++) {
    let category = products[i];
    for (let j = 0, l = category.list.length; j < l; j++) {
      if (category.list[j]['PRODUCT_ID'] == productId) {
        return category.list[j];
      }
    }
  }
  return {};
};

export let getProductByCpId = function (productId) {
  let products = getProductListStore() || [];
  let cpProductId = getCpProductId();
  for (let i = 0, len = products.length; i < len; i++) {
    let category = products[i];
    for (let j = 0, l = category.list.length; j < l; j++) {
      if (
        category.list[j]['PRODUCT_ID'] == productId &&
        category.list[j]['CP_PRODUCT_ID'] == cpProductId
      ) {
        return category.list[j];
      }
    }
  }
  return {};
};

export let getProductByIdAndRemark = (productId, remark) => {
  let products = getProductListStore() || [];
  for (let i = 0, len = products.length; i < len; i++) {
    let category = products[i];
    for (let j = 0, l = category.list.length; j < l; j++) {
      if (
        category.list[j]['PRODUCT_ID'] == productId &&
        category.list[j]['CP_PRODUCT_ID'] == remark
      ) {
        return category.list[j];
      }
    }
  }
  return {};
};

export let getLocationNameByVal = function (val) {
  let locations = getLocaLclStor();
  for (let i = 0, len = locations.length; i < len; i++) {
    if (val == locations[i].value) {
      return locations[i].name;
    }
  }
  return '';
};

export let getLocaLclStor = function () {
  let str = sessionStorage.getItem(LOCA_LCLSTOR_KEY);
  let locations = [];
  try {
    locations = JSON.parse(str) || [];
  } catch (e) {
    locations = [];
  }
  return locations;
};

export let storeHrefParam = function () {
  let params = getAllHrefParam();
  sessionStorage.setItem(STORE_PAGE_HREF_KEY, JSON.stringify(params));
  return params;
};

export let storeProductParam = function (params) {
  sessionStorage.setItem(STORE_PAGE_HREF_KEY, JSON.stringify(params));
  return params;
};

export let getStoreHrefParam = function () {
  let params = {};
  try {
    params = JSON.parse(sessionStorage.getItem(STORE_PAGE_HREF_KEY));
  } catch (e) { }
  return params;
};

export const appendStoreHrefLocation = function (locationVal) {
  let params = getStoreHrefParam();
  params['location'] = locationVal;
  sessionStorage.setItem(STORE_PAGE_HREF_KEY, JSON.stringify(params));
};

export let storeServerId = function (serverId) {
  sessionStorage.setItem(STORE_SERVER_ID_KEY, serverId);
};

export let getServerId = function () {
  return sessionStorage.getItem(STORE_SERVER_ID_KEY);
};

export let storeServerName = function (serverName) {
  sessionStorage.setItem(STORE_SERVER_NAME_KEY, serverName);
};

export let getServerName = function () {
  return sessionStorage.getItem(STORE_SERVER_NAME_KEY);
};

const getFirtPayableWay = function (allPytypes) {
  const list = normalizePayTypeList(allPytypes);
  let payType = '';
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i]?.price_list?.length > 0) {
      payType = list[i];
      break;
    }
  }

  if (payType == '') {
    payType = list[0];
  }

  return payType;
};

export const setDefaultPayType = function (defaultPayType) {
  try {
    let allPytypes = getPayTYpeListStore();
    let payType = '';
    for (let i = 0, len = allPytypes.length; i < len; i++) {
      let sameFPayType = allPytypes[i]?.f_pay_type == defaultPayType?.f_pay_type;
      let samePayType = allPytypes[i]?.pay_type == defaultPayType?.pay_type;
      if (sameFPayType && samePayType) {
        payType = allPytypes[i];
        break;
      }
    }
    if (payType === '' || !payType?.price_list?.length) {
      payType = getFirtPayableWay(allPytypes);
    }

    if (!payType || typeof payType !== 'object') {
      payType = {};
    }

    sessionStorage.setItem(PAY_TYPE_KEY, JSON.stringify(payType));
  } catch (e) {
    console.error(e);
  }
};

export const getDefaultPayType = function () {
  try {
    const payType = JSON.parse(sessionStorage.getItem(PAY_TYPE_KEY));
    return payType && typeof payType === 'object' ? payType : {};
  } catch (e) {
    return {};
  }
};

export const setLastedPayType = function (lastedPaytype) {
  try {
    sessionStorage.setItem(LASTED_TYPE_KEY, JSON.stringify(lastedPaytype));
  } catch (e) {
    console.error(e);
  }
};

export const getLastedPayType = function () {
  try {
    const lastedPayType = JSON.parse(sessionStorage.getItem(LASTED_TYPE_KEY));
    return lastedPayType && typeof lastedPayType === 'object' ? lastedPayType : {};
  } catch (e) {
    return {};
  }
};

export const storeCoinName = function (coinName) {
  sessionStorage.setItem(COIN_NAME_KEY, coinName);
};

export const getCoinName = function () {
  return sessionStorage.getItem(COIN_NAME_KEY);
};

export const storeCurLocation = function (location) {
  sessionStorage.setItem(CUR_LOCATION_KEY, location);
};

export const getCurLocation = function () {
  return sessionStorage.getItem(CUR_LOCATION_KEY);
};

export const getDefaultPrice = function () {
  let defaultPrice = '';
  try {
    defaultPrice = JSON.parse(sessionStorage.getItem(DEFAULT_PRICE_KEY));
  } catch (e) { }
  return defaultPrice;
};

export const setDefaultPrice = function (curPrice) {
  try {
    sessionStorage.setItem(DEFAULT_PRICE_KEY, JSON.stringify(curPrice));
  } catch (e) { }
};

export const storeHref = function () {
  sessionStorage.setItem(RE_STORE_HREF_KEY, location.href);
};

export const getStoreHref = function () {
  return sessionStorage.getItem(RE_STORE_HREF_KEY);
};

export const setWebviewPageFlag = function () {
  return sessionStorage.setItem(WEBVIEW_PAY_FLAG, 1);
};

export const getWebviewPageFlag = function () {
  return sessionStorage.getItem(WEBVIEW_PAY_FLAG);
};

// 保存最近一次使用的信用卡类型，用于下次选择信用卡支付时默认选中
export const setCreditCardRecord = function (record) {
  localStorage.setItem(CREDIT_CARD_RECORD, JSON.stringify(record));
};
export const setPaypalAgreementRecord = function (record) {
  localStorage.setItem(PAYPAL_AGREEMENT_RECORD, JSON.stringify(record));
};

export const getCreditCardRecord = function () {
  let record = localStorage.getItem(CREDIT_CARD_RECORD) || '';
  try {
    record = JSON.parse(record);
  } catch (e) { }
  return record;
};

export const getPaypalAgreementRecord = function () {
  let record = localStorage.getItem(PAYPAL_AGREEMENT_RECORD) || '';
  try {
    record = JSON.parse(record);
  } catch (e) { }
  return record;
};

export const getAllHrefParam = function () {
  return {
    gameId: getHrefParam('gameId'),
    serverId: getHrefParam('serverId'),
    roleId: getHrefParam('roleId'),
    roleName: getHrefParam('roleName'),
    packageName: getHrefParam('packageName'),
    userId: getHrefParam('userId'),
    productId: getHrefParam('productId'),
    cpProductId: getHrefParam('cpProductId'),
    devicePlate: getHrefParam('devicePlate'),
    remark: getHrefParam('remark'),
    location: getHrefParam('location'),
    appLanguage: getHrefParam('appLanguage'),
    language: getHrefParam('language'),
    productType: getHrefParam('productType')
  };
};

export const storeBirthCoupons = function (birthCoupons) {
  try {
    localStorage.setItem(BIRTH_COUPONS, JSON.stringify(birthCoupons));
  } catch (e) { }
};

export const getBirthCoupons = function () {
  let birthCoupons = localStorage.getItem(BIRTH_COUPONS);
  try {
    birthCoupons = JSON.parse(birthCoupons);
    if (birthCoupons && birthCoupons?.length > 0) {
      return birthCoupons;
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

export const storeAreaLimitAutoPopup = function (info) {
  try {
    localStorage.setItem(AREA_LIMIT_AUTO_POPUO, JSON.stringify(info));
  } catch (e) { }
};

export const getAreaLimitAutoPopup = function () {
  let info = {};
  try {
    info = JSON.parse(localStorage.getItem(AREA_LIMIT_AUTO_POPUO)) || info;
  } catch (e) { }
  return info;
};
